export default {
  'menu.membership': 'Membership',
  'pages.membership.action.addItem': 'Add item',
  'pages.membership.action.column': 'Action',
  'pages.membership.action.detail': 'Detail',
  'pages.membership.action.edit': 'Edit',
  'pages.membership.action.editLevel': 'Edit level',
  'pages.membership.action.query': 'Query',
  'pages.membership.action.refresh': 'Refresh',
  'pages.membership.action.submit': 'Submit',
  'pages.membership.action.unverify': 'Unverify',
  'pages.membership.action.verify': 'Verify',
  'pages.membership.drawer.levelDetail': 'Level detail',
  'pages.membership.empty.data': 'No data',
  'pages.membership.empty.result': 'No result',
  'pages.membership.entitlement.checkType': 'Check type',
  'pages.membership.entitlement.key': 'Entitlement key',
  'pages.membership.entitlement.resetCycle': 'Reset cycle',
  'pages.membership.entitlement.unit': 'Unit',
  'pages.membership.entitlement.value': 'Value',
  'pages.membership.level.code': 'Code',
  'pages.membership.level.description': 'Description',
  'pages.membership.level.levelId': 'Level ID',
  'pages.membership.level.name': 'Name',
  'pages.membership.level.sortOrder': 'Sort',
  'pages.membership.level.status': 'Status',
  'pages.membership.message.entitlementMissing': 'Missing entitlement key',
  'pages.membership.message.saved': 'Saved',
  'pages.membership.message.userIdRequired': 'User ID is required',
  'pages.membership.modal.editEntitlement': 'Edit entitlement',
  'pages.membership.modal.editLevel': 'Edit level',
  'pages.membership.section.entitlements': 'Entitlements',
  'pages.membership.section.levelDefinition': 'Level definition',
  'pages.membership.tab.levels': 'Levels',
  'pages.membership.tab.usage': 'Usage operations',
  'pages.membership.tab.users': 'User membership',
  'pages.membership.title': 'Membership',
  'pages.membership.usage.adjust': 'Adjust',
  'pages.membership.usage.bizId': 'Biz ID',
  'pages.membership.usage.bizType': 'Biz type',
  'pages.membership.usage.check': 'Check',
  'pages.membership.usage.deduct': 'Deduct',
  'pages.membership.usage.deductValue': 'Deduct',
  'pages.membership.usage.delta': 'Delta',
  'pages.membership.usage.nextResetAt': 'Next reset at',
  'pages.membership.usage.reason': 'Reason',
  'pages.membership.usage.refill': 'Refill',
  'pages.membership.usage.remaining': 'Remaining',
  'pages.membership.usage.requiredValue': 'Required',
  'pages.membership.usage.result': 'Operation result',
  'pages.membership.usage.scope': 'Scope',
  'pages.membership.usage.total': 'Total',
  'pages.membership.usage.trigger': 'Trigger',
  'pages.membership.usage.triggerRef': 'Trigger ref',
  'pages.membership.user.changeType': 'Change type',
  'pages.membership.user.createdAt': 'Created at',
  'pages.membership.user.currentLevel': 'Current level',
  'pages.membership.user.durationDays': 'Duration days',
  'pages.membership.user.fromLevel': 'From level',
  'pages.membership.user.levelHistory': 'Level history',
  'pages.membership.user.setLevel': 'Set user level',
  'pages.membership.user.source': 'Source',
  'pages.membership.user.sourceRef': 'Source ref',
  'pages.membership.user.toLevel': 'To level',
  'pages.membership.user.twitterUrl': 'Twitter URL',
  'pages.membership.user.usageSummary': 'Usage summary',
  'pages.membership.user.userId': 'User ID',
  'pages.membership.user.verifyAction': 'Verify user',
  'pages.membership.user.verifyStatus': 'Verify status',
};
